import React, { Component } from 'react'
import Dialog from './../../../modules/Dialog'
import classNames from 'classnames'
import Button from './../../../modules/Button'
import injectStyles from 'react-jss'

const styles = {
  cancelButton: {
    position: 'absolute',
    bottom: 56,
    left: 0,
    right: 0,
    cursor: 'pointer',
  },
  cancelButtonDisabled: {
    color: 'grey',
  },
  button: {
    width: 358,
    height: 42,
    boxSizing: 'border-box',
    fontSize: 14,
    padding: 0,
  },
  input: {
    width: 358,
    height: 42,
    boxSizing: 'border-box',
    paddingLeft: 22,
    paddingRight: 22,
    fontSize: 14,
    color: '#333333',
  },
}

class NewRepositoryDialog extends Component {

  state = {
    newRepositoryName: '',
  }

  onNewRepositoryNameChange = e => this.setState({ newRepositoryName: e.target.value })

  onNewBranchSave = () => {
    const { newRepositoryName } = this.state
    this.props.createRepository(newRepositoryName)
  };

  render = () => {
    const {
      onClose,
      classes,
      saving,
    } = this.props

    const {
      newRepositoryName
    } = this.state

    return <Dialog>
      <h3>New Repository</h3>
      <br /><br /><br />
      <input
        placeholder="Name of the repository..."
        value={newRepositoryName}
        onChange={this.onNewRepositoryNameChange}
        disabled={saving}
        className={classes.input}
      />
      <br /><br /><br />
      <Button
        className={classes.button}
        onClick={this.onNewBranchSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
      <div
        className={classNames({
          [classes.cancelButton]: true,
          [classes.cancelButtonDisabled]: saving,
        })}
        onClick={saving ? null : onClose}
      >Cancel</div>
    </Dialog>
  }
}

export default injectStyles(styles)(NewRepositoryDialog)



// WEBPACK FOOTER //
// ./src/pages/RepositorySelect/NewRepositoryDialog/NewRepositoryDialog.js